module.exports = __webpack_public_path__ + "static/media/hamster-final.86759c55.svg";